import { RefObject, useContext, useEffect, useMemo, useState } from 'react';
import { ZahtjevContext } from "../context/ZahtjevProvider";

export function useOnScreen(ref: RefObject<HTMLDivElement | null>, trigger: boolean = false, defaultValue = true) {
    const [isIntersecting, setIntersecting] = useState(defaultValue);
    const { isScrollToTop } = useContext(ZahtjevContext);

    const observer = useMemo(
      () => new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting)),
      []
    );

    useEffect(() => {
        if (ref?.current && isScrollToTop) {
            observer.observe(ref.current);
            return () => observer.disconnect();
        }
    }, [ref, isScrollToTop, observer, trigger]);

    return isIntersecting;
}
